// extracted by mini-css-extract-plugin
module.exports = {"body":"CheckBox_body__ZEfY7","checkbox":"CheckBox_checkbox__10kss","active":"CheckBox_active__ABrUL"};